import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from 'components/Loader';

import './style.scss';

const InfoCard = ({ title, children, showCard, showContent, pending }) => {
  if (!showCard && !showContent && !pending) {
    return <></>;
  }

  let render;
  if (pending) {
    render = <Loader type="small" color="#000" />;
  } else if (!showContent) {
    render = <></>;
  } else {
    if (typeof children === 'string' && children.length > 100) {
      render = children.slice(0, 100) + '...';
    } else {
      render = children;
    }
  }

  return (
    <div className="infocard">
      <div className="title">{title}</div>
      <div className="infocard-block" title={typeof children === 'string' ? children : ''}>
        {render}
      </div>
    </div>
  );
};

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  pending: PropTypes.bool,
  showCard: PropTypes.bool,
  showContent: PropTypes.bool,
};

InfoCard.defaultProps = {
  pending: false,
  showCard: true,
  showContent: true,
};

export { InfoCard };
